import { render, staticRenderFns } from "./InvoiceArticleFilter.vue?vue&type=template&id=df134ae6&scoped=true&"
import script from "./InvoiceArticleFilter.vue?vue&type=script&lang=js&"
export * from "./InvoiceArticleFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df134ae6",
  null
  
)

export default component.exports